import React, { useState } from "react";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  const buttondownUser = process.env.REACT_APP_BUTTONDOWN_USERNAME;
  const externalAction = process.env.REACT_APP_NEWSLETTER_ACTION; // e.g. Formspree/Mailchimp action URL

  const onSubmit = (e) => {
    e.preventDefault();
    const valid = /[^@\s]+@[^@\s]+\.[^@\s]+/.test(email);
    if (!valid) {
      setStatus("error");
      return;
    }
    setStatus("success");
    setEmail("");
  };

  return (
    <section id="Newsletter" className="newsletter-section">
      <div className="newsletter-container">
        <h2 className="section-heading">Subscribe to the newsletter</h2>
        <p className="newsletter-subtext text-md">
          Insights on DevOps, Cloud, and engineering productivity — delivered occasionally.
        </p>

        {/* Buttondown embed (no API key needed) */}
        {buttondownUser ? (
          <form
            className="newsletter-form"
            action={`https://buttondown.email/api/emails/embed-subscribe/${buttondownUser}`}
            method="post"
            target="popupwindow"
            onSubmit={() =>
              window.open(
                `https://buttondown.email/${buttondownUser}`,
                "popupwindow"
              )
            }
          >
            <input
              type="email"
              name="email"
              className="newsletter-input"
              placeholder="Your email address"
              aria-label="Email address"
              required
            />
            <button type="submit" className="btn btn-primary newsletter-btn">
              Subscribe
            </button>
          </form>
        ) : externalAction ? (
          // Generic external action (Formspree/Mailchimp)
          <form className="newsletter-form" action={externalAction} method="POST" target="_blank">
            <input
              type="email"
              name="email"
              className="newsletter-input"
              placeholder="Your email address"
              aria-label="Email address"
              required
            />
            <button type="submit" className="btn btn-primary newsletter-btn">
              Subscribe
            </button>
          </form>
        ) : (
          // Client-side placeholder (shows success locally)
          <form className="newsletter-form" onSubmit={onSubmit} noValidate>
            <input
              type="email"
              className="newsletter-input"
              placeholder="Your email address"
              aria-label="Email address"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (status !== "idle") setStatus("idle");
              }}
              required
            />
            <button type="submit" className="btn btn-primary newsletter-btn">
              Subscribe
            </button>
          </form>
        )}

        {status === "success" && !buttondownUser && !externalAction && (
          <p className="newsletter-feedback success">Thanks! You're subscribed.</p>
        )}
        {status === "error" && !buttondownUser && !externalAction && (
          <p className="newsletter-feedback error">Please enter a valid email.</p>
        )}
      </div>
    </section>
  );
}
